export default {
  // backend:'http://dev1.com/',
  // backend: "http://dev2.com/",
  // backend:'https://www.map-o.com/',
  backend: "/",
  // backend:'http://localhost:881/'
  // backend: "http://localhost:81/",
  frontRoot: "/ui/",
  LogStatus: Object.freeze({
    success: "success",
    fail: "fail",
    ongoing: "ongoing",
    cancel_by_user: "cancel_by_user",
    cancel_by_system: "cancel_by_system",
  }),
  LogType: Object.freeze({
    add: "add",
    mod: "mod",
    del: "del",
  }),
  LayerType: Object.freeze({
    LineString: "LineString",
    MultiLineString: "MultiLineString",
    Polygon: "Polygon",
    MultiPolygon: "MultiPolygon",
    Point: "Point",
    MultiPoint: "MultiPoint",
  }),
  FeatureType: Object.freeze({
    WMS: "WMS",
    WFS: "WFS",
    WCS: "WCS",
    WPS: "WPS",
    TMS: "TMS",
  }),
  GsShapes: ["square", "circle", "triangle", "star", "cross", "x"],
  FontStyles: ["normal", "italic", "oblique"],
  WfsDownloadFormats: {
    WMS: [
      { value: "image/gif", title: "GIF" },
      { value: "rss", title: "GeoRSS" },
      { value: "image/geotiff", title: "GeoTiff" },
      { value: "image/geotiff8", title: "GeoTiff 8-bits" },
      { value: "image/jpeg", title: "JPEG" },
      { value: "image/vnd.jpeg-png", title: "JPEG-PNG" },
      { value: "image/vnd.jpeg-png8", title: "JPEG-PNG8" },
      { value: "application/atom+xml", title: "AtomPub" },
      {
        value: "application/vnd.google-earth.kmz+xml",
        title: "KML (compressed)",
      },
      {
        value: "application/vnd.google-earth.kml+xml;mode=networklink",
        title: "KML (network link)",
      },
      { value: "application/vnd.google-earth.kml", title: "KML (plain)" },
      { value: "application/pdf", title: "PDF" },
      { value: "image/png", title: "PNG" },
      { value: "image/png; mode=8bit", title: "PNG 8bit" },
      { value: "image/svg+xml", title: "SVG" },
      { value: "image/tiff", title: "Tiff" },
      { value: "image/tiff8", title: "Tiff 8-bits" },
      { value: "application/json;type=utfgrid", title: "UTFGrid" },
    ],
    WFS: [
      {
        value: "csv",
        title: "CSV",
      },
      {
        value: "text/xml; subtype=gml/3.1.1",
        title: "gml_3_1_1",
      },
      {
        value: "GML2",
        title: "gml_2",
      },
      {
        value: "KML",
        title: "kml",
      },
      {
        value: "SHAPE-ZIP",
        title: "shape_zip",
      },
      {
        value: "gml32",
        title: "gml_3_2",
      },
      {
        value: "application/json",
        title: "json",
      },
      {
        value: "application/vnd.google-earth.kml xml",
        title: "kml_xml",
      },
      {
        value: "application/vnd.google-earth.kml+xml",
        title: "kml_plus",
      },
      {
        value: "gml3",
        title: "gml_3",
      },
      {
        value: "json",
        title: "json_simple",
      },
      {
        value: "text/csv",
        title: "csv_text",
      },
      {
        value: "text/xml; subtype=gml/2.1.2",
        title: "gml_2_1_2",
      },
      {
        value: "text/xml; subtype=gml/3.2",
        title: "gml_3_2_text",
      },
    ],
  },
  WmsDownloadFormats: {
    WMS: [
      { value: "application/atom+xml", title: "AtomPub" },
      { value: "image/gif", title: "GIF" },
      { value: "rss", title: "GeoRSS" },
      { value: "image/geotiff", title: "GeoTiff" },
      { value: "image/geotiff8", title: "GeoTiff 8-bits" },
      { value: "image/jpeg", title: "JPEG" },
      { value: "image/vnd.jpeg-png", title: "JPEG-PNG" },
      { value: "image/vnd.jpeg-png8", title: "JPEG-PNG8" },
      {
        value: "application/vnd.google-earth.kmz+xml",
        title: "KML (compressed)",
      },
      {
        value: "application/vnd.google-earth.kml+xml;mode=networklink",
        title: "KML (network link)",
      },
      { value: "application/vnd.google-earth.kml", title: "KML (plain)" },
      { value: "application/pdf", title: "PDF" },
      { value: "image/png", title: "PNG" },
      { value: "image/png; mode=8bit", title: "PNG 8bit" },
      { value: "image/svg+xml", title: "SVG" },
      { value: "image/tiff", title: "Tiff" },
      { value: "image/tiff8", title: "Tiff 8-bits" },
      { value: "application/json;type=utfgrid", title: "UTFGrid" },
    ],
    WFS: [],
  },
  KoreaBbox: {
    lonMin: 122.90207653833662,
    latMin: 31.84828203072665,
    lonMax: 131.69055827251188,
    latMax: 40.744222040701544,
  },
  KoreaBbox3857: [13773044, 3681967, 14717397, 5348676],
};
